<template>
  <div class="container">
    <div class="row">
      <h3 class="mx-auto">Work and Well being Survey</h3>
    </div>
    <div class="row mx-auto" style="margin-bottom: -60px">
      <p style="font-size: 1.2em">
        The following 17 statements are about how you feel at work. Please read
        each statement carefully and decide if you ever feel this way about your
        job. If you have never had this feeling, cross the “0” (zero) in the
        space after the statement. If you have had this feeling, indicate how
        often you feel it by crossing the number (from 1 to 6) that best
        describes how frequently you feel that way using the scale depicted
        below.
      </p>
    </div>
    <div class="sticky-top" style="padding-top: 60px; z-index:1;">
      <div class="row mx-auto bg-white pt-3">
        <div class="col">
          <p class="max-auto text-center m-0"><strong>0</strong></p>
        </div>
        <div class="col">
          <p class="max-auto text-center m-0"><strong>1</strong></p>
        </div>
        <div class="col">
          <p class="max-auto text-center m-0"><strong>2</strong></p>
        </div>
        <div class="col">
          <p class="max-auto text-center m-0"><strong>3</strong></p>
        </div>
        <div class="col">
          <p class="max-auto text-center m-0"><strong>4</strong></p>
        </div>
        <div class="col">
          <p class="max-auto text-center m-0"><strong>5</strong></p>
        </div>
        <div class="col">
          <p class="max-auto text-center m-0"><strong>6</strong></p>
        </div>
      </div>
      <div class="row border-bottom mx-auto bg-white">
        <div class="col"><p class="max-auto text-center">Never</p></div>
        <div class="col">
          <p class="max-auto text-center">A few times a year or less</p>
        </div>
        <div class="col">
          <p class="max-auto text-center">Once a month or less</p>
        </div>
        <div class="col">
          <p class="max-auto text-center">a few times a month</p>
        </div>
        <div class="col"><p class="max-auto text-center">Once a week</p></div>
        <div class="col">
          <p class="max-auto text-center">A few times a week</p>
        </div>
        <div class="col"><p class="max-auto text-center">Every day</p></div>
      </div>
    </div>

    <b-form @submit="onSubmit">
      <div
        v-for="(question, index) in questions"
        :key="question.index"
        class="m-3 justify-content-center"
      >
        <uwesQuestion
          @newdata="handleData($event, index)"
          :question="question"
        />
      </div>
      <div class="text-center">
        <b-button type="submit" variant="primary">Submit</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import uwesQuestion from "@/components/engagement/forms/uwesQuestion.vue";
import { engagementScaleMethods } from "@/mixins/engagement/engagementScaleMethods.js";

export default {
  mixins: [engagementScaleMethods],
  props: ["uwesId"],
  components: {
    uwesQuestion,
  },
  computed: {
    ...mapGetters("users", ["getClaims", "getMe"]),
  },
  data() {
    return {
      questions: [
        {
          question: "At my work, I feel bursting with energy",
          name: "q1",
          tag: "vigor",
        },
        {
          question: "I find the work that I do full of meaning and purpose",
          name: "q2",
          tag: "dedication",
        },
        {
          question: "Time flies when I'm working",
          name: "q3",
          tag: "absorption",
        },
        {
          question: "At my job, I feel strong and vigorous (active)",
          name: "q4",
          tag: "vigor",
        },
        {
          question: "I am enthusiastic about my job",
          name: "q5",
          tag: "dedication",
        },
        {
          question: "When I am working, I forget everything else around me",
          name: "q6",
          tag: "absorption",
        },
        {
          question: "My job inspires me",
          name: "q7",
          tag: "dedication",
        },
        {
          question: "When I get up in the morning, I feel like going to work",
          name: "q8",
          tag: "vigor",
        },
        {
          question: "I feel happy when I am working intensely",
          name: "q9",
          tag: "absorption",
        },
        {
          question: "I am proud of the work that I do",
          name: "q10",
          tag: "dedication",
        },
        {
          question: "I am immersed in my work",
          name: "q11",
          tag: "absorption",
        },
        {
          question: "I can continue working for very long periods at a time",
          name: "q12",
          tag: "vigor",
        },
        {
          question: "To me, my job is challenging",
          name: "q13",
          tag: "dedication",
        },
        {
          question: "I get carried away when I’m working",
          name: "q14",
          tag: "absorption",
        },
        {
          question: "At my job, I am very resilient, mentally",
          name: "q15",
          tag: "vigor",
        },
        {
          question: "It is difficult to detach myself from my job",
          name: "q16",
          tag: "absorption",
        },
        {
          question:
            "At my work I always persevere, even when things do not go well",
          name: "q17",
          tag: "vigor",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleData: function (e, x) {
      this.questions.splice(x, 1, { ...this.questions[x], value: e });
    },
    async onSubmit(event) {
      event.preventDefault();
      let uwes = {
        answers: this.questions,
        userId: this.uwesId,
        companyId: this.getClaims.companyId,
      };

      await this.$store.dispatch("uwes/set", uwes);

      await this.swalToastSuccess(this.$t("ui.saved"));
      this.$router.push("/employeeprofile/" + this.getMe.id);
    },
  },
};
</script>

<style scoped lang="scss">
// @import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>